import { TDR } from 'tdr-common';
import config from '../common/config';
import Availability = TDR.Availability;
import { useQuery, useIsMutating } from '@tanstack/react-query';
import { MUTATION_KEY } from './releaseCheckoutSession';

const CACHE_SETTINGS = {
	staleTime: 2 * 60 * 1000, // 2 minutes - timeslots change as reservations are made
	gcTime: 5 * 60 * 1000, // 5 minutes - keep in cache for quick navigation
	refetchOnMount: false, // Don't refetch on component mount if cache is fresh
	refetchOnWindowFocus: false // Don't refetch when user returns to tab
};

export function useTimeslots(input: TDR.Availability.getTimeSlotsInput) {
	const isReleasing = useIsMutating({
		mutationKey: [MUTATION_KEY],
		exact: true
	});

	const query = useQuery({
		enabled: !isReleasing && !!input.dateStr && input.tableIds?.length > 0,
		queryKey: ['timeslots', input],
		queryFn: () => getTimeslots(input),
		...CACHE_SETTINGS
	});

	return query;
}

async function getTimeslots(input: Availability.getTimeSlotsInput): Promise<Availability.getTimeSlotsOutput> {
	const response = await fetch(`${config.apiHost}/getTimeSlots`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(input)
	});

	const responsePayload = await response.json() as Availability.getTimeSlotsOutput;

	if (!response.ok) {
		throw response;
	}
	else if (!responsePayload?.success) {
		throw Error('Could Not Get Available Time slots');
	}

	return responsePayload;
}
